export default __webpack_public_path__ + "static/media/oscer-pres-nipple-discharge.faeb121c.svg";